import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from 'src/app/common/data.service';
import { AppTokenHandler } from 'src/app/common/app-token-handler';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.css']
})
export class PageNotFoundComponent implements OnInit {

    ErrorMessage: any;
    constructor(private appToken: AppTokenHandler, public route: ActivatedRoute, private data: DataService, private _route: Router) { }

    ngOnInit() {
        this.ErrorMessage = this.GetErrorMessageOnIDBehalf(this.route.snapshot.paramMap.get('ID'));
    }
    GetErrorMessageOnIDBehalf(Id: any): any {
        let ErrorMsg =
            // tslint:disable-next-line:max-line-length
            'During the processing of the last request an error occurred. Please try again or contact the system administrator if you continue to experience problems.';
        if (Id === '1') {
            ErrorMsg = 'You are not authorized to access this application.Please contact Administrator';
        }
        if (Id === '2') {
            this.appToken.clearSessionToken();
            // tslint:disable-next-line:max-line-length
            ErrorMsg = 'During the processing of the last request an error occurred. Please try again or contact the system administrator if you continue to experience problems.';
        }
        if (Id === '3') {
            // tslint:disable-next-line:max-line-length
            ErrorMsg = 'Session Expired, Please log in again';
        }
        if (Id === '4') {
            // tslint:disable-next-line:max-line-length
            ErrorMsg = 'You are not authorized person on this Page';
        }
        if (Id === '5') {
            // tslint:disable-next-line:max-line-length
            ErrorMsg = 'Page you are looking for does not exist or been removed.Please contact the system administrator';
        }
        return ErrorMsg;
    }

    Login() {
        this.appToken.clearSessionToken();
        this._route.navigate(['/login']);
    }
}
